import { ArrowDown } from '@rsos/assets/icons';
import styles from './QueueNewMessagesIndicator.module.css';
import { useQueueNotifications } from './QueueNotificationsContext';

/**
 * Floating pill shown at the bottom of the queue when items with new messages
 * are scrolled below the viewport. Clicking it scrolls to the first such item.
 * Mirrors the transcription "New Messages" indicator pattern.
 */
const QueueNewMessagesIndicator = () => {
  const { outOfViewUnreadIds, scrollToFirstUnread } = useQueueNotifications();

  const count = outOfViewUnreadIds.length;
  if (count === 0) return null;

  return (
    <button
      type="button"
      className={styles.indicator}
      onClick={scrollToFirstUnread}
      data-name="queue-new-messages-indicator"
    >
      <ArrowDown height={10} width={10} />
      {count} new {count === 1 ? 'message' : 'messages'} below
    </button>
  );
};

export default QueueNewMessagesIndicator;
